import { takeLatest, takeEvery } from 'redux-saga/effects';

import {
  USER_CHALLENGES,
  USER_CHALLENGE,
  USER_CHALLENGE_DECLARATIONS,
  USER_CHALLENGE_DECLARATION_REQUEST,
  POST_USER_PARTICIPATION,
  TOTAL_USER_PARTICIPATION,
  CHALLENGE_RESULTS,
  CHALLENGE_RANKS,
  POST_USER_CHALLENGE_PHOTO_RESULTS,
  CHALLENGE_RESULT_VOTE,
  CHALLENGE_RESULT_UNVOTE,
  SET_SELECTED_CHALLENGE_DATA_ACTION,
} from 'actions/challenge.actions';

import {
  getUserChallengeDeclarationsSaga,
  getUserChallengesSaga,
  getUserChallengeSaga,
  getUserChallengeDeclarationSaga,
  getTotalUsersParticipationSaga,
  postUserParticipationSaga,
  getChallengeResultsSaga,
  getChallengeRanksSaga,
  getChallengeResultVoteSaga,
  getChallengeResultUnvoteSaga,
  postUserChallengePhotoResultsSaga,
  setSelectedChallengeDataSaga,
} from 'sagas/challenge.saga';

import { REQUEST } from 'services/api';

export function* setSelectedChallengeDataSagaWatcher(): unknown {
  yield takeEvery(
    SET_SELECTED_CHALLENGE_DATA_ACTION[REQUEST],
    setSelectedChallengeDataSaga,
  );
}

export function* getUserChallengesSagaWatcher(): unknown {
  yield takeEvery(USER_CHALLENGES[REQUEST], getUserChallengesSaga);
}

export function* getUserChallengeSagaWatcher(): unknown {
  yield takeEvery(USER_CHALLENGE[REQUEST], getUserChallengeSaga);
}

export function* getUserChallengeDeclarationsSagaWatcher(): unknown {
  yield takeEvery(
    USER_CHALLENGE_DECLARATIONS[REQUEST],
    getUserChallengeDeclarationsSaga,
  );
}

export function* getUserChallengeDeclarationSagaWatcher(): unknown {
  yield takeEvery(
    USER_CHALLENGE_DECLARATION_REQUEST,
    getUserChallengeDeclarationSaga,
  );
}

export function* getTotalUsersParticipationSagaWatcher(): unknown {
  yield takeEvery(
    TOTAL_USER_PARTICIPATION[REQUEST],
    getTotalUsersParticipationSaga,
  );
}

export function* postUserParticipationSagaWatcher(): unknown {
  yield takeLatest(POST_USER_PARTICIPATION[REQUEST], postUserParticipationSaga);
}

export function* getChallengeResultsSagaWatcher(): unknown {
  yield takeEvery(CHALLENGE_RESULTS[REQUEST], getChallengeResultsSaga);
}

export function* getChallengeRanksSagaWatcher(): unknown {
  yield takeEvery(CHALLENGE_RANKS[REQUEST], getChallengeRanksSaga);
}

export function* postUserChallengePhotoSagaWatcher(): unknown {
  yield takeEvery(
    POST_USER_CHALLENGE_PHOTO_RESULTS[REQUEST],
    postUserChallengePhotoResultsSaga,
  );
}

export function* getChallengeResultVoteSagaWatcher(): unknown {
  yield takeEvery(CHALLENGE_RESULT_VOTE[REQUEST], getChallengeResultVoteSaga);
}

export function* getChallengeResultUnvoteSagaWatcher(): unknown {
  yield takeEvery(
    CHALLENGE_RESULT_UNVOTE[REQUEST],
    getChallengeResultUnvoteSaga,
  );
}
